import { DateTime } from 'luxon'
import React, { useContext, useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { AppContext } from '../../context/AppContext'
import { UserContext } from '../../context/UserContext'
import Button from '../buttons/Button/Button'
import useGym from '../../hooks/useGym'
import useMe from '../../hooks/useMe'
import SegmentedInput from '../inputs/SegmentedInput/SegmentedInput'
import ToggleInput from '../inputs/ToggleInput/ToggleInput'
import Avatar from '../atoms/Avatar/Avatar'
import Modal from './Modal'
import { EditableUserAttributes } from '../../services'

type Props = {
  isVisible: boolean
  onDismiss: () => void
}

const EditName = ({ isVisible, onDismiss }: Props) => {
  const { register, reset, handleSubmit, setFocus } =
    useForm<EditableUserAttributes>()

  const { user } = useContext(UserContext)
  const { error, isLoading, clearErrors, updateMyAttribute } = useMe({
    onSuccess: onDismiss,
  })

  useEffect(() => {
    setFocus('name')
  }, [isVisible, error])

  const save: SubmitHandler<EditableUserAttributes> = (data) =>
    updateMyAttribute(data)

  return (
    <Modal
      isVisible={isVisible}
      onCancel={() => {
        clearErrors()
        reset()
        onDismiss()
      }}
      size="small"
      title="Edit Name"
      buttons={{
        secondary: {
          onClick: () => {
            reset()
            clearErrors()
            onDismiss()
          },
        },
        primary: {
          onClick: handleSubmit(save),
          label: 'Save',
          isSubmitButton: true,
          disabled: error ? true : false,
          isLoading: isLoading,
        },
      }}
    >
      <form onSubmit={handleSubmit(save)}>
        <input
          defaultValue={user.name}
          maxLength={24}
          style={{
            borderColor: error ? 'var(--accent-red)' : '',
          }}
          {...register('name', {
            maxLength: 64,
            onChange: () => clearErrors(),
          })}
        />
        {error && (
          <p style={{ marginTop: '8px', color: 'var(--accent-red)' }}>
            {error}
          </p>
        )}
      </form>
    </Modal>
  )
}

export default EditName
